// Module
var code = "<section ng-class=\"::{ 'today': $ctrl.isCurrentDay }\"> <div> <cr-calendar-event data=\"event\" ng-repeat=\"event in $ctrl.schedule.events\"></cr-calendar-event> </div> <hr class=\"current-time\" ng-if=\"::$ctrl.isCurrentDay\" ng-style=\"{ 'top': $ctrl.currentTimeInPx + 'px' }\"/> </section> ";
// Exports
export default code;